import { create } from "zustand";
import { initialState, TFiltersStore } from "./filters.state";
import { createFilterActions } from "./filters.actions";

/**
 * State management store of the V3 search - Dynamic filters
 * @example
 * ```
 * const yearFilters = useFiltersStore((state) => state.yearFilters)
 * const dispatch = useFiltersStore((state) => state.dispatch)
 * dispatch({ type: SearchActions.SET_YEAR_FILTERS, payload: yearFilters })
 * ```
 */
export const useFiltersStore = create<TFiltersStore>((set, get) => ({
    ...initialState,
    ...createFilterActions(set, get)
}));
